// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IYVN","colBig":"styles_colBig__1fJQl","colSmall":"styles_colSmall__2-4Jx","shopifyNameWrapper":"styles_shopifyNameWrapper__wi6u_"};